import {observable} from 'mobx';
import {construct, createArrayInstance, ModelProperties} from '../utils';
import {OfferProductLocaleContent} from './offer-product-locale-content';

export class OfferProductLocaleKey {
    @observable id!: number;

    @observable name!: string;

    @observable whitespaces!: boolean;

    @observable charLimit!: number;

    @observable enabled!: boolean;

    @observable content?: OfferProductLocaleContent[];

    constructor(key?: ModelProperties<OfferProductLocaleKey>) {
        if (key) {
            construct(this, key);
            this.content = createArrayInstance(OfferProductLocaleContent, key.content);
        }
    }
}